module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gauge', {
    attrs: {
      "initial-data": _vm.chartData
    }
  })
},staticRenderFns: []}